var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"1400px","height":"700px"}},[_c('div',{staticClass:"info"},[_vm._v("\n    Pano index:"+_vm._s(_vm.index)+"\n    "),_c('button',{on:{"click":_vm.change}},[_vm._v("Toggle")])]),_vm._v(" "),_c('Pano',{attrs:{"source":_vm.urls[_vm.index]},on:{"on-load":_vm.onLoad}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-284ded5b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/test/TestVR.vue
// module id = 1311
// module chunks = 3